export const environment = {

  production: false,
  ENCRYPT_SECRET_KEY: "AGEFOP!development@ci",
  API_ENDPOINT: "https://api.agefop.selys.app/api/"

};
